/* eslint-disable ssr-friendly/no-dom-globals-in-module-scope */
/* eslint-disable no-console */
/* eslint-disable complexity */
/* eslint-disable class-methods-use-this */
import React from 'react';
import BaseClass from 'components/BaseClass';
import { wrapComponent } from 'utils/framework';
import {
    Text, Flex, Container, Box
} from 'components/ui';
import Header from 'components/FrictionlessCheckout/Header/Header';
import CompactFooter from 'components/Footer/CompactFooter';
import DeliverTo from 'components/FrictionlessCheckout/DeliverTo';
import DeliverToReleaseThree from 'components/FrictionlessCheckout/DeliverToReleaseThree';
import FrictionlessCheckoutConstants from 'utils/FrictionlessCheckoutConstants';
import SddCard from 'components/FrictionlessCheckout/SddSection/SddCard';
import PickupInfoCard from 'components/FrictionlessCheckout/BopisSection/PickupInfoCard';
import CheckoutLayout from 'components/FrictionlessCheckout/CheckoutLayout/CheckoutLayout';
import TopContent from 'components/FrictionlessCheckout/TopContent';
import AddAGiftMessage from 'components/FrictionlessCheckout/AddAGiftMessage/AddAGiftMessage';
import CostSummary from 'components/FrictionlessCheckout/CostSummary';
import BIBenefits from 'components/FrictionlessCheckout/BIBenefits';
import ShippingMethods from 'components/FrictionlessCheckout/ShippingMethods';
import Payment from 'components/FrictionlessCheckout/Payment';
import PaymentReleaseFour from 'components/FrictionlessCheckout/PaymentReleaseFour';
import GiftCardDeliverySection from 'components/FrictionlessCheckout/GiftCardDeliverySection';
import ZeroCheckoutItems from 'components/FrictionlessCheckout/ZeroCheckoutItems/ZeroCheckoutItems';
import creditCardUtils from 'utils/CreditCard';
import sessionExtensionService from 'services/SessionExtensionService';
import FrictionlessUtils from 'utils/FrictionlessCheckout';
import Venmo from 'utils/Venmo';
import checkoutUtils from 'utils/Checkout';
import { FC_CHECKOUT_SECTIONS } from 'constants/frictionlessCheckout';

const { loadChaseTokenizer } = creditCardUtils;

const {
    ORDER_TYPES: { GET_IT_SHIPPED }
} = FrictionlessCheckoutConstants;

const isFCFinalReleaseEnabled = FrictionlessUtils.isFCFinalReleaseEnabled();

class FrictionlessCheckout extends BaseClass {
    unsubscribe = null;

    constructor(props) {
        super(props);
        this.state = {
            forcePaymentSectionRender: false,
            isInitialUnverifiedEditActive: this.isAddressUnverifiedOnLoad(props),
            focus: {
                shippingMethod: false,
                giftCardDeliverTo: false,
                payment: false,
                deliverTo: false,
                pickupInfo: false
            }
        };
    }

    // Helper to check if address is unverified on initial checkout load
    // Returns true if address verification flag is explicitly false (not undefined)
    isAddressUnverifiedOnLoad = props => {
        const currentShippingGroup = props.sameDayShippingGroup?.shippingGroup || props.hardGoodShippingGroup;
        const isAddressVerified = currentShippingGroup?.address?.isAddressVerified;

        return isAddressVerified === false;
    };

    // Called when user explicitly saves address section (even if address is still unverified/poor)
    // Clears the forced edit mode so the section collapses normally after save
    onAddressSectionSaved = () => {
        if (this.state.isInitialUnverifiedEditActive) {
            this.setState({ isInitialUnverifiedEditActive: false });
        }
    };

    confirmSection = sectionName => {
        const { setAddressNeedsConfirmation, setGiftCardAddressNeedsConfirmation, setPaymentMethodNeedsConfirmation } = this.props;

        switch (sectionName) {
            case FC_CHECKOUT_SECTIONS.DELIVER_TO.name:
                setAddressNeedsConfirmation(true);

                break;
            case FC_CHECKOUT_SECTIONS.GIFT_CARD_DELIVERY.name:
                setGiftCardAddressNeedsConfirmation(true);

                break;
            case FC_CHECKOUT_SECTIONS.PAYMENT.name:
                setPaymentMethodNeedsConfirmation(true);

                break;
            default:
                break;
        }
    };

    componentDidMount() {
        this.unsubscribe = this.props.basketUpdated();

        if (Sephora.configurationSettings.isChasePaymentEnabled) {
            loadChaseTokenizer();
        }

        sessionExtensionService.setExpiryTimer(this.props.requestCounter);

        if (!this.pageRendered) {
            //SOASTA Tracking
            Sephora.Util.Perf.report('Page Rendered');
            this.pageRendered = true;
        }

        // Initialize URL-based routing
        if (this.props.historyLocation) {
            this.updateStatePerHistoryPathChange(this.props.historyLocation);
        }

        // Skip auto-routing when address is unverified, user must fix address first
        // Otherwise auto-routing sends user to payment (backend marks shipping as complete despite unverified address)
        if (!this.state.isInitialUnverifiedEditActive) {
            FrictionlessUtils.updateCheckoutURLBasedOnOrderCompleteness();
        }

        // For hard reloads on mweb where we dont open new tab, token
        // for venmo needs to be re initialized.
        Venmo.onCheckoutReload({
            defaultPayment: this.props.defaultPayment,
            callback: checkoutUtils.placeOrderSuccess
        });
    }

    componentDidUpdate(prevProps) {
        // Force payment section for standard e-fulfilled orders, but NOT for reward-only
        const forcePaymentSectionRender = this.props.creditCardsCount && this.props.isEfullfillmentOrder && !this.props.isRewardOnlyZeroDollarOrder;

        if (prevProps.creditCardsCount !== this.props.creditCardsCount && forcePaymentSectionRender) {
            this.setState({ forcePaymentSectionRender: true });
        }

        // Turn off forced unverified edit mode only when address is explicitly verified
        // Using === true to avoid clearing on undefined (e.g. order refresh may omit the field)
        if (this.state.isInitialUnverifiedEditActive) {
            const currentShippingGroup = this.props.sameDayShippingGroup?.shippingGroup || this.props.hardGoodShippingGroup;
            const isAddressVerified = currentShippingGroup?.address?.isAddressVerified;

            if (isAddressVerified === true) {
                this.setState({ isInitialUnverifiedEditActive: false });
            }
        }

        // Listen for URL changes
        if (this.props.historyLocation && prevProps.historyLocation !== this.props.historyLocation) {
            this.updateStatePerHistoryPathChange(this.props.historyLocation);
        }
    }

    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    extractCheckoutPath = path => {
        const pathRegex = /[^/?]+(?=\/$|$)/;
        const match = pathRegex.exec(path);

        return match ? match[0] : 'checkout';
    };

    getOpenFocusedSection = checkoutPath => {
        for (const key of Object.keys(FC_CHECKOUT_SECTIONS)) {
            const section = FC_CHECKOUT_SECTIONS[key];
            const name = section.name;
            const sectionName = section.sectionName;

            if (this.state.focus[name] && checkoutPath !== section.path) {
                const completenessChecker = FrictionlessUtils.SECTION_COMPLETION_CHECKERS?.[name];
                const hasErrors = completenessChecker ? !completenessChecker() : false;

                return { name, hasErrors, sectionName };
            }
        }

        return null;
    };

    updateStatePerHistoryPathChange = router => {
        const focus = {};
        const checkoutPath = this.extractCheckoutPath(router.path);
        const openSectionInfo = this.getOpenFocusedSection(checkoutPath);

        if (openSectionInfo?.hasErrors) {
            this.confirmSection(openSectionInfo.name);
            const error = {};
            error[openSectionInfo.sectionName] = this.props.localization.confirmSelection;
            this.props.setCheckoutSectionErrors(error);
        }

        // Reset all sections to unfocused
        Object.keys(FC_CHECKOUT_SECTIONS).forEach(key => {
            focus[FC_CHECKOUT_SECTIONS[key].name] = false;
        });

        focus.isInitialized = true;

        // Set the matching section to focused based on URL
        Object.keys(FC_CHECKOUT_SECTIONS).forEach(key => {
            const section = FC_CHECKOUT_SECTIONS[key];

            if (checkoutPath === section.path) {
                focus[section.name] = true;
            }
        });

        this.setState({ focus });
    };

    getCheckoutConfiguration = () => {
        const componentsToRender = [];
        let sectionNumber = 1;
        const {
            isBopisOrder,
            hardGoodShippingGroup,
            isZeroCheckout,
            isHalAvailable,
            isSdd,
            isAutoReplenishBasket,
            isGis,
            isGiftCardAvailable,
            orderId,
            giftMessagingStatus,
            hasRRC,
            isSDUOnlyOrder,
            isElectronicShippingGroup,
            hasSDUInBasket,
            sameDayShippingGroup,
            hardGoodOrGiftCardShippingGroup,
            contentData,
            physicalGiftCardShippingGroup,
            hasStandardItems,
            isChangePermittedForShippingMethods,
            isNewUserFlow,
            shouldRenderPayment,
            isShippableOrder,
            hasSDUOnlyInSddBasket,
            orderHasPhysicalGiftCard,
            isGuestCheckout,
            zeroDollarHigherRedeemPointsCVV,
            zeroDollarHigherRedeemPointsNotCVV,
            isEfullfillmentOrder,
            hasAutoReplenishment
        } = this.props;

        const isPhysicalGiftCardOnly = physicalGiftCardShippingGroup && !hardGoodShippingGroup && !isSdd;
        const shouldRenderGiftCardDeliverySection = physicalGiftCardShippingGroup && !isZeroCheckout && !isSdd;

        if (isZeroCheckout && !isShippableOrder && !isSDUOnlyOrder) {
            componentsToRender.push(<ZeroCheckoutItems />);
        }

        if (shouldRenderGiftCardDeliverySection) {
            componentsToRender.push(
                <GiftCardDeliverySection
                    sectionNumber={sectionNumber}
                    orderType={GET_IT_SHIPPED}
                    shippingGroup={physicalGiftCardShippingGroup}
                    isZeroCheckout={isZeroCheckout}
                    isNewUserFlow={isNewUserFlow}
                    orderHasPhysicalGiftCard={orderHasPhysicalGiftCard}
                    isGuestCheckout={isGuestCheckout}
                    isEditViewFromURL={this.state.focus.giftCardDeliverTo}
                />
            );
            sectionNumber++;
        }

        if (
            (!isBopisOrder && hardGoodShippingGroup) ||
            (hasSDUInBasket && isSDUOnlyOrder === false) ||
            (isElectronicShippingGroup === false && !hasSDUInBasket && !isPhysicalGiftCardOnly) ||
            (isElectronicShippingGroup && isSdd)
        ) {
            const Component = isFCFinalReleaseEnabled ? DeliverToReleaseThree : DeliverTo;
            const currentShippingGroup = sameDayShippingGroup?.shippingGroup || hardGoodShippingGroup;

            // Force section to expand if address is unverified on initial checkout load
            // User can save a bad address on account page and then go to checkout, so we need to check for unverified address
            const computedIsCollapsed = this.state.isInitialUnverifiedEditActive
                ? false
                : physicalGiftCardShippingGroup && !physicalGiftCardShippingGroup?.isComplete && !isSdd;
            const computedIsEditViewFromURL = this.state.focus.deliverTo || this.state.isInitialUnverifiedEditActive;
            // True when any other checkout section (other than DeliverTo) is currently being edited.
            // `isInitialized` is a meta flag on `focus`, not a section, so it's excluded.
            const isAnotherCheckoutSectionOpen = Object.entries(this.state.focus).some(
                ([key, value]) => value && key !== FC_CHECKOUT_SECTIONS.DELIVER_TO.name && key !== 'isInitialized'
            );

            componentsToRender.push(
                <Component
                    sectionNumber={sectionNumber}
                    orderType={GET_IT_SHIPPED}
                    shippingGroup={currentShippingGroup}
                    isZeroCheckout={isZeroCheckout}
                    isHalAvailable={isHalAvailable}
                    isSdd={isSdd}
                    hasSDUOnlyInSddBasket={hasSDUOnlyInSddBasket}
                    isAutoReplenishBasket={isAutoReplenishBasket}
                    isGis={isGis}
                    isNewUserFlow={isNewUserFlow}
                    isCollapsed={computedIsCollapsed}
                    orderHasPhysicalGiftCard={orderHasPhysicalGiftCard}
                    giftCardShippingGroup={physicalGiftCardShippingGroup}
                    hasCmsContent={Object.keys(contentData).length > 0}
                    isEditViewFromURL={computedIsEditViewFromURL}
                    isAnotherCheckoutSectionOpen={isAnotherCheckoutSectionOpen}
                    skipAutoRouting={this.state.isInitialUnverifiedEditActive}
                    onAddressSaved={this.onAddressSectionSaved}
                />
            );
            sectionNumber++;
        }

        if ((isGiftCardAvailable && orderId && giftMessagingStatus && !isZeroCheckout) || (isZeroCheckout && isShippableOrder && !isSdd)) {
            componentsToRender.push(
                <AddAGiftMessage
                    orderId={orderId}
                    giftMessagingStatus={giftMessagingStatus}
                />
            );
        }

        if (
            (!isBopisOrder && !isSdd && (!isZeroCheckout || (isZeroCheckout && hasRRC) || isAutoReplenishBasket) && !isPhysicalGiftCardOnly) ||
            (isZeroCheckout && isShippableOrder && !isSdd)
        ) {
            componentsToRender.push(
                <ShippingMethods
                    sectionNumber={sectionNumber}
                    infoModalData={contentData?.fulfillmentTypeAutoReplenish}
                    isChangePermitted={isChangePermittedForShippingMethods}
                    isNewUserFlow={isNewUserFlow}
                    isPhysicalGiftCard={!isBopisOrder && physicalGiftCardShippingGroup}
                    middleZone={contentData.middleZone}
                    isEditMode={this.state.focus.shippingMethod}
                />
            );
            sectionNumber++;
        }

        if (isSdd) {
            componentsToRender.push(
                <SddCard
                    sectionNumber={sectionNumber}
                    infoModalData={contentData?.fulfillmentTypeSameDayDelivery}
                    isNewUserFlow={isNewUserFlow}
                />
            );
            sectionNumber++;

            if (
                (hasSDUInBasket && !isSDUOnlyOrder && hardGoodOrGiftCardShippingGroup) ||
                (hasStandardItems && !hasSDUInBasket && !isPhysicalGiftCardOnly) ||
                isElectronicShippingGroup
            ) {
                componentsToRender.push(
                    <ShippingMethods
                        sectionNumber={sectionNumber}
                        infoModalData={contentData?.fulfillmentTypeAutoReplenish}
                        isChangePermitted={isChangePermittedForShippingMethods}
                        isNewUserFlow={isNewUserFlow}
                        isPhysicalGiftCard={!isBopisOrder && physicalGiftCardShippingGroup}
                        middleZone={contentData.middleZone}
                        isEditMode={this.state.focus.shippingMethod}
                        isSdd
                    />
                );
                sectionNumber++;
            }
        }

        if (isBopisOrder) {
            componentsToRender.push(
                <PickupInfoCard
                    sectionNumber={sectionNumber}
                    isEditViewFromURL={this.state.focus.pickupInfo}
                />
            );
            sectionNumber++;
        }

        if (shouldRenderPayment || this.state.forcePaymentSectionRender) {
            const shippingGroup = sameDayShippingGroup?.shippingGroup || hardGoodShippingGroup;
            const PaymentComponent = isFCFinalReleaseEnabled ? PaymentReleaseFour : Payment;

            componentsToRender.push(
                <PaymentComponent
                    sectionNumber={(!isEfullfillmentOrder || isSDUOnlyOrder) && sectionNumber}
                    isNewUserFlow={isNewUserFlow && !isBopisOrder}
                    hasSavedAddress={isSDUOnlyOrder || !!shippingGroup?.address || isBopisOrder}
                    hasGiftCardInOrder={shouldRenderGiftCardDeliverySection}
                    isGuestCheckout={isGuestCheckout}
                    isShippableOrder={isShippableOrder}
                    zeroDollarHigherRedeemPointsCVV={zeroDollarHigherRedeemPointsCVV}
                    zeroDollarHigherRedeemPointsNotCVV={zeroDollarHigherRedeemPointsNotCVV}
                    isEfullfillmentOrder={isEfullfillmentOrder}
                    orderHasPhysicalGiftCard={orderHasPhysicalGiftCard}
                    forcePaymentSectionRender={this.state.forcePaymentSectionRender}
                    renderSubTitle={hasSDUInBasket || isAutoReplenishBasket}
                    isEditViewFromURL={this.state.focus.payment}
                    skipPaymentAutoOpen={this.state.isInitialUnverifiedEditActive}
                    alternatePaymentDetailsModal={contentData?.alternatePaymentDetails}
                    hasSDUInBasket={hasSDUInBasket}
                    hasAutoReplenishment={hasAutoReplenishment}
                />
            );
            sectionNumber++;
        }

        return componentsToRender;
    };

    getMainContent = () => {
        const { contentData, isShippableOrder } = this.props;

        return (
            <>
                <TopContent
                    content={contentData?.contentZone}
                    isZeroCheckout={this.props.isZeroCheckout}
                    isShippableOrder={isShippableOrder}
                />
                {this.getCheckoutConfiguration()}
            </>
        );
    };

    getSidebarContent = () => {
        const {
            biBenifits, biBenefitsModals, isBopisOrder, isZeroCheckout, hasPromoCodes
        } = this.props;
        const showBiBenefits = biBenifits.length > 0 && ((isZeroCheckout && hasPromoCodes) || !isZeroCheckout);

        return (
            <Flex
                flexDirection={['column-reverse', 'column']}
                gap={[4, 4, 5]}
                position={[null, 'sticky']}
                top={[null, 0]}
            >
                <CostSummary isZeroCheckout={this.props.isZeroCheckout} />
                {showBiBenefits && (
                    <BIBenefits
                        biBenifits={biBenifits}
                        biBenefitsModals={biBenefitsModals}
                        isBopisOrder={isBopisOrder}
                    />
                )}
            </Flex>
        );
    };

    render() {
        const { isBopisOrder, localization } = this.props;

        return (
            <Box
                minHeight='100vh'
                display='flex'
                flexDirection='column'
            >
                <Header />
                <Container px={[4, 5, 4]}>
                    <Text
                        is='h1'
                        fontSize={['lg', 'lg', 'xl']}
                        paddingTop={[4, 4, 5]}
                        fontWeight='bold'
                        children={isBopisOrder ? localization.bopisTitle : localization.sadTitle}
                    />
                    <CheckoutLayout
                        mainContent={this.getMainContent()}
                        sidebarContent={this.getSidebarContent()}
                    />
                </Container>
                <Box marginTop='auto'>
                    <CompactFooter hideWebsiteFeedback />
                </Box>
            </Box>
        );
    }
}

export default wrapComponent(FrictionlessCheckout, 'FrictionlessCheckout', true);
